/* eslint-disable @typescript-eslint/no-throw-literal */
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { IAnatomopathologicalTest, IFetchAnatomopathologicalTestsOfSurgery } from '~/interfaces'
import { fetchAnatomopathologicalTestsOfSurgery, message } from '~/services'
import { hasObjectValue } from '~/utils'

const UNIQUE_KEY = 'anatomopathologicalTestsOfSurgery'

export const useFetchAnatomopathologicalTestsOfSurgery = (
  fetchParams: IFetchAnatomopathologicalTestsOfSurgery | null,
  config?: UseQueryOptions<IAnatomopathologicalTest[], Error, IAnatomopathologicalTest[]>
): UseQueryResult<IAnatomopathologicalTest[], Error> => {
  const hasFetchParams = hasObjectValue({ ...fetchParams })

  const fetcher = async () => {
    if (!fetchParams) throw new Error('fetchParams is required')

    try {
      const response = await fetchAnatomopathologicalTestsOfSurgery(fetchParams)
      const isResponseEmpty = response.length <= 0

      if (isResponseEmpty) {
        throw message('detailsMedicalEvents.emptyAnatomopathologicalTestSurgeryRelated')
      }

      return response
    } catch (error) {
      if (typeof error === 'string') throw new Error(error)
      throw new Error(message('messages.genericUnexpectedError'))
    }
  }

  return useQuery<IAnatomopathologicalTest[], Error>([UNIQUE_KEY, fetchParams?.pathParams], fetcher, {
    cacheTime: Infinity,
    staleTime: Infinity,
    enabled: hasFetchParams,
    ...config
  })
}
